import { render, staticRenderFns } from "./historique_relances.vue?vue&type=template&id=fd9d0c16&"
import script from "./historique_relances.vue?vue&type=script&lang=js&"
export * from "./historique_relances.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports